import { auth } from 'google-auth-library';

async function getClient(keys, scopes){
    const client = auth.fromJSON(keys);
    client.scopes = scopes;
    return client;
}

export default getClient;
export {getClient};